//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { MainApi } from '@/api'
export default {
  // name: 'xxxxxxxx',
  components: {
    //	xxxxxxxx
  },
  data() {
    return {
      searchTips: '地区/银行/风险/投资天数/金额',
      bankArr: ['不限', '国有制银行', '股份制银行', '地方性股份制银行'],
      bankNum: 0,
      riskArr: ['不限', 'R1', 'R2', 'R3', 'R4', 'R5'],
      riskNum: 0,
      isLayerShows: false,
      filterMenuArr: [
        {
          name: '起购金额',
          enName: 'PurchaseAmount',
          sort: '',
        },
        {
          name: '认购期限',
          enName: 'InvestmentDays',
          sort: '',
        },
        {
          name: '年化收益率',
          enName: 'AnnualizedIncomeMin',
          sort: 'desc',
        },
        {
          name: '预计收益',
          enName: 'RealIncomeMoney',
          sort: '',
        },
      ],
      serachObj: {
        money: '',
        InvestmentDays: '',
        BankType: 0,
        RiskType: 0,
        ProvinceId: 0,
      },
      provinceArr: [],
      searchVal: '',
      getProvince: '',
      searchInputVal: '',
    }
  },
  created() {
    this.getProvincesApi()
  },
  mounted() {},
  methods: {
    openLayerFn() {
      this.isLayerShows = true
    },
    getLocationFn() {
      if (localStorage.getItem('province')) {
        this.getProvince = localStorage.getItem('province')
        this.setProvincesFn()
      } else {
        const citysearch = new AMap.CitySearch()
        citysearch.getLocalCity((status, result) => {
          // //console.log('城市返回result', status, result)

          if (status === 'complete' && result.info === 'OK') {
            if (result && result.province && result.bounds) {
              //console.log('Result', result)

              this.getProvince = result.province
              localStorage.setItem('province', this.getProvince)
              this.setProvincesFn()
            }
          } else {
            //失败
          }
        })
      }
    },
    setProvincesFn() {
      if (this.getProvince) {
        const filterProvinceArr = this.provinceArr.filter(item => {
          return item.Name == this.getProvince
        })
        // //console.log('filterProvinceId', filterProvinceArr)
        this.serachObj.ProvinceId = filterProvinceArr[0].Id
        // //console.log('this.serachObj.ProvinceId', this.serachObj.ProvinceId)
      }
    },
    closeLayerFn() {
      this.isLayerShows = false
    },
    getProvincesApi() {
      MainApi.getProvincesApi()
        .then(data => {
          this.provinceArr = data.Result
          this.getLocationFn()
        })
        .catch(() => {})
    },
    filterMenuFn(index) {
      this.filterMenuArr[index].sort =
        this.filterMenuArr[index].sort === ''
          ? 'asc'
          : this.filterMenuArr[index].sort === 'desc'
          ? 'asc'
          : 'desc'
      this.filterMenuArr.forEach((item, key) => {
        if (index !== key) {
          item.sort = ''
        }
      })
      // this.$emit('changeFilterVal', {
      this.$emit('changeSearchVal', {
        sort: this.filterMenuArr[index].sort,
        order: this.filterMenuArr[index].enName,
      })
    },
    changeBankFn(idx) {
      this.bankNum = idx
      // this.serachObj.BankType = this.bankArr[idx]
      this.serachObj.BankType = idx
    },
    changeRiskFn(idx) {
      this.riskNum = idx

      this.serachObj.RiskType =
        this.riskArr[idx] === '不限' ? 0 : this.riskArr[idx]
    },
    searchFn() {
      const dayReg = /^\d*$/
      const numReg = /^\d*\.{0,1}\d{0,1}$/
      // const numReg = /^\d+(\.\d+)?$/

      if (
        this.serachObj.InvestmentDays &&
        !dayReg.test(this.serachObj.InvestmentDays)
      ) {
        this.$vux.toast.show({
          type: 'warn',
          text: '投资期限天数请输入数字',
        })
        return false
      }
      if (this.serachObj.money && !numReg.test(this.serachObj.money)) {
        this.$vux.toast.show({
          type: 'warn',
          text: '投资金额仅能保留小数点后一位',
          // text: '投资金额请输入数字或1位小数',
        })
        return false
      }

      this.$emit('changeSearchVal', this.serachObj)

      let provinceSelectObj = this.provinceArr.filter(
        item => this.serachObj.ProvinceId == item.Id,
      )

      let searchDays = this.serachObj.InvestmentDays
        ? '/' + this.serachObj.InvestmentDays + '天'
        : ''
      let searchMoney = this.serachObj.money
        ? '/' + this.serachObj.money + '万元'
        : ''

      let riskTypes =
        this.serachObj.RiskType == 0 ? '不限' : this.serachObj.RiskType

      this.searchInputVal = `${provinceSelectObj[0].Name}/${
        this.bankArr[this.serachObj.BankType]
      }/${riskTypes + searchDays + searchMoney}`

      this.closeLayerFn()
    },
    resetFn() {
      this.serachObj = {
        money: '',
        InvestmentDays: '',
        BankType: 0,
        RiskType: 0,
        ProvinceId: 0,
      }
      this.bankNum = 0
      this.riskNum = 0
      this.$emit('changeSearchVal', this.serachObj)
      this.searchInputVal = ''
      //重置倒底要不要关闭弹窗
      this.closeLayerFn()
    },
  },
  computed: {},
  // watch: {
  //   getProvince() {
  //     // //console.log('有变动了')
  //   },
  // },
}



// WEBPACK FOOTER //
// ./src/pages/components/indexTop.vue